import React, { Fragment, FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { getTypeName, localize } from "src/l10n";

interface IProps {
    notification: Spintr.INotification;
}

const ContentReviewDeclined: FunctionComponent<IProps> = (props) => {
    const notification = props.notification as Spintr.IContentReviewDeclined;
    if (!notification) {
        return null;
    }
    const typeText = getTypeName(notification.uberType, { case: "possessive" }).toLowerCase();

    return (
        <Fragment>
            {localize("Din")}
            {" " + typeText + " "}
            <Link to={"/publishing"}>{notification.uberName}</Link>
            {" " + localize("HarBlivitAvslagen").toLowerCase()}.
        </Fragment>
    );
};

export default ContentReviewDeclined;
